<template>
  <div class="container">
    <el-form ref="searchForm" :model="searchData" inline>
      <el-form-item label="UID">
        <el-input v-model.number="searchData.user_id" size="mini" />
      </el-form-item>
      <el-form-item label="负责人">
        <el-select v-model="selectedMember" placeholder="请选择" size="mini" >
          <el-option
              v-for="item in memberList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
          </el-option>
        </el-select> 
      </el-form-item>

      <el-form-item label="状态">
        <el-select v-model="searchData.statuses" placeholder="请选择" size="mini" multiple>
          <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
          </el-option>
        </el-select> 
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="handleSearch">
            查找
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="data"
      @row-click="handleViewPending"
    >
    
      <el-table-column
        prop="avatar"
        label="微信头像">
        
        <template slot-scope="scope">
          <el-avatar shape="square" size="large" :src="scope.row.avatar || ''"/>
        </template>
      </el-table-column>

      <el-table-column
        prop="nickname"
        label="昵称"
        sortable
      />

      <el-table-column
        prop="user_id"
        label="UID"
        sortable
      />

      <el-table-column
        prop="invite_id"
        label="邀请人ID"
        sortable
      />

      <el-table-column
        prop="mobile"
        label="手机号"
        sortable
      />

      <el-table-column
        prop="time"
        label="注册时间"
        sortable
      />
      
      <el-table-column
        prop="last_login"
        label="最后登录时间"
        sortable
        />

      <el-table-column
        prop="last_remark_time"
        label="最新备注"
        sortable
      >
        <template scope="scope">
          <div> {{ scope.row.last_remark_time }} </div>
          <el-tooltip class="item" effect="dark" :content="scope.row.last_remark_content" placement="bottom">
            <div class="text-wrapper" :title="scope.row.last_remark_content"> {{ scope.row.last_remark_content }} </div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="last_pending_time"
        label="最近待办"
        sortable
      >
        <template scope="scope">
          <div> {{ scope.row.last_pending_time }} </div>
          <el-tooltip class="item" effect="dark" :content="scope.row.last_pending_content" placement="bottom">
            <div class="text-wrapper" > {{ scope.row.last_pending_content }} </div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="status"
        label="状态"
        :formatter="statusFormatter"
        sortable
      />

      <el-table-column
        prop="member_id"
        label="负责人"
        sortable
      >
        <template scope="scope">
          <div> {{ scope.row.member_name }}/{{ scope.row.member_id }} </div>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
      >
        <template scope="scope">   
          <el-button-group>
            <el-button type="primary" size="mini" @click="handleMoveTeam(scope.row)"> 移动组 </el-button>
            <el-button type="primary" size="mini" @click="handleMoveMember(scope.row)"> 移动客服 </el-button>
          </el-button-group>
        </template>
      </el-table-column>

    </el-table>

    <pager
      ref="pager"
      api="customer_list"
      :filter="filter"
      :sort="sort"
      model="cs"
      :defaultPageSize="50"
      @data-changed="onDataChanged"
    />

    <el-dialog 
      title="移动组"
      :visible.sync="showMoveTeam"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleMoveTeamFormDialogClose"
    >

      <el-form ref="moveTeamForm" :model="moveTeamForm" :rules="editRules" label-position="right">
        <el-form-item prop="team_id" label="团队:" label-width="150px">
          <el-select v-model="moveTeamForm.team_id" placeholder="请选择" size="mini" >
            <el-option
                v-for="item in teamList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
            </el-option>
          </el-select> 
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showMoveTeam = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveMoveTeam"> 确 定 </el-button>
      </div>
    </el-dialog>

    <el-dialog 
      title="移动客服"
      :visible.sync="showMoveMember"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleMoveMemberFormDialogClose"
    >

      <el-form ref="moveMemberForm" :model="moveMemberForm" :rules="editRules" label-position="right">
        <el-form-item prop="member_id" label="客服:" label-width="150px">
          <el-select v-model="moveMemberForm.member_id" placeholder="请选择" size="mini" >
            <el-option
                v-for="item in getMemberListByTeam()"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
            </el-option>
          </el-select> 
        </el-form-item>
        
        <!-- <el-form-item prop="role" label="角色:" label-width="150px">
          <el-input v-model="moveMemberForm.role" />
        </el-form-item> -->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showMoveMember = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveMoveMember"> 确 定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pager from "../ui/Pager"
  import request from "@/api/request"

  const LOCAL_STORAGE_KEY = 'CUSTOMER_MEMBER_ID',

  initMoveTeamForm = {
    user_id: null,
    team_id: null
  },

  initMoveMemberForm = {
    user_id: null,
    member_id: null,
    role: 'community_operation'
  },

  initRules = {
    team_id: [
      {
        required: true,
        message: "团队不能为空"
      },
    ],
    member_id: [
      {
        required: true,
        message: "客服不能为空"
      }
    ],
    role: [
      {
        required: true,
        message: "角色不能为空"
      }
    ]
  },
  initStatus = [
    {
      value: 0,
      name: '新分配'
    },
    {
      value: 50,
      name: '正在联系'
    },
    {
      value: 100,
      name: '已建立联系'
    },
    {
      value: 200,
      name: '准备成交'
    },
    {
      value: 300,
      name: '已成交'
    },
    {
      value: 900,
      name: '放弃'
    }
  ]
  export default {
    name: 'CustomerList',
    components: { Pager },
    data () {
      return {
        searchData: {},
        data: [],
        memberList: [],
        filter: {},
        sort: [
          {
            field: 'id',
            reverse: true
          }
        ],
        teamList: [],
        moveTeamForm: { ...initMoveTeamForm },
        moveMemberForm: { ...initMoveMemberForm },
        statusList: { ...initStatus },
        selectedMember: null,
        showMoveTeam: false,
        showMoveMember: false,
        teamId: null
      }
    },
    computed: {
      editRules: function () {
          return { ...initRules }
      },
    },
    watch: {
      selectedMemberList(value) {
        localStorage.setItem(LOCAL_STORAGE_KEY, value)
      }
    },
    created() {
      if (localStorage.getItem(LOCAL_STORAGE_KEY)) {
        this.selectedMember = ~~localStorage.getItem(LOCAL_STORAGE_KEY)
        if (this.selectedMember) {
          this.filter.member_id = this.selectedMember
        }
      }
      this.$set(this.searchData, 'statuses', [200])
      this.filter = this.searchData
      this.getMemberList()
    },
    methods: {
      statusFormatter(row, column, cellValue) {
        const status = initStatus.find(item => item.value === cellValue)
        return status ? status.name : ''        
      },
      onDataChanged: function (data) {
        this.data = data
        // 时间格式排序有问题，需要转成string
        for (let i = 0; i < this.data.length; i++) {
          if (!this.data[i].last_pending_time) {
            this.data[i].last_pending_time = ''
          }
          if (!this.data[i].last_remark_time) {
            this.data[i].last_remark_time = ''
          }
        }
        localStorage.setItem(LOCAL_STORAGE_KEY, this.selectedMember)
      },
      handleSearch() {
        let filter = {}
        if (this.searchData.user_id) {
          filter.user_id = this.searchData.user_id
        }
        if (this.selectedMember) {
          filter.member_id = this.selectedMember
        }
        if (this.searchData.statuses !== undefined && this.searchData.statuses.length > 0 ) {
          filter.statuses = this.searchData.statuses
        }
        this.filter = filter
      },
      handleSaveMoveTeam() {
        this.$refs.moveTeamForm.validate(val => {
          if (val) {
            request
              .cs
              .post("customer_move", this.moveTeamForm).then(() => {
                this.$message.success('调整成功')
                this.showMoveTeam = false
                this.$refs.pager.loadData()
              })
          }
        })
      },
      handleSaveMoveMember() {
        this.$refs.moveMemberForm.validate(val => {
          if (val) {
            request
              .cs
              .post("customer_member_set", this.moveMemberForm)
              .then(() => {
                this.$message.success('调整成功')
                this.showMoveMember = false
                this.$refs.pager.loadData()
              })
          }
        })
      },
      handleViewPending(row) {
        if (!this.showMoveTeam && !this.showMoveMember) {
          this.goToPendingView(row.user_id)
        }
      },
      getTeamList() {
        request
          .cs
          .post("team_list", {
              range: [0, 200],
              filter: { status: 0 }
          })
          .then(response => {
            if (response.data.list) {
              this.teamList = response.data.list
            }
          })
      },
      getMemberList() {
        request
          .cs
          .post("member_list", {
              range: [0, 200],
              filter: { status: 0 }
          }).then(response => {
            this.memberList = [{ id: 0, name: '全部' }]
            if (response.data.list) {
              response.data.list.forEach(item => this.memberList.push(item))
            }
          })
      },
      handleMoveTeam(row) {
        this.moveTeamForm.team_id = row.team_id
        this.showMoveTeam = true
        this.moveTeamForm.user_id = row.user_id
        this.getTeamList()
      },
      handleMoveMember(row) {
        this.teamId = row.team_id
        this.showMoveMember = true
        this.moveMemberForm.user_id = row.user_id
        this.moveMemberForm.member_id = row.member_id
        this.getTeamList()
      },
      handleMoveTeamFormDialogClose() {
        this.moveTeamForm = { ...initMoveTeamForm }
        this.$refs.moveTeamForm.clearValidate()
      },
      handleMoveMemberFormDialogClose() {
        this.teamId = null
        this.moveMemberForm = { ...initMoveMemberForm }
        this.$refs.moveMemberForm.clearValidate()
      },
      goToPendingView(userId) {
        // this.$router.push(`/custom-service/pending/${userId}`)
        const { href } = this.$router.resolve({ path: `/custom-service/pending/${userId}` });
        window.open(href, "_blank")
      },
      getMemberListByTeam() {
        return this.teamId ? this.memberList.filter(item => {
          return item.team === this.teamId && item.roles.indexOf('community_operation') >= 0
        }) : []
      }
    }
  }
</script>

<style scoped>
.text-wrapper {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}
</style>
